<template>
  <div class="type-box">

    <!-- 类型 -->
    <div ref="ptype" class="ptype" :class="{'active-option':activeType.newVal =='ptype'}"
      @mouseleave="mouseLeave('ptype')" @mouseenter="mouseEnter('ptype')">
      <div class="ptype-title">
        <span>类型：{{ptype}}</span>
        <!-- <span>类型</span> -->
        <i class="el-icon-arrow-down"></i>
      </div>
      <div class="type-shade"></div>
    </div>

    <!-- 题型 -->
    <div ref="qtype" class="qtype" :class="{'active-option':activeType.newVal=='qtype'}"
      @mouseleave="mouseLeave('qtype')" @mouseenter='mouseEnter("qtype")'>
      <div class="qtype-title">
        <span>题型：{{qtype}}</span>
        <!-- <span>题型</span> -->
        <i class="el-icon-arrow-down"></i>
      </div>
      <div class="type-shade"></div>
    </div>

    <!-- 难度 -->
    <div ref="diff" class="diff" :class="{'active-option':activeType.newVal=='diff'}" @mouseleave="mouseLeave('diff')"
      @mouseenter='mouseEnter("diff")'>
      <div class="diff-title">
        <span>难度：{{diff}}</span>
        <!-- <span>难度</span> -->
        <i class="el-icon-arrow-down"></i>
      </div>
      <div class="type-shade"></div>
    </div>

    <!-- 展示内容 -->
    <div @mouseleave="mouseLeave('typeOption')" @mouseenter='mouseEnter("typeOption")'
      @click.stop="optionClick('typeOption')" ref="typeOption" class="type-option">
      <div class="type-option-box">
        <el-radio @change='optionChange' v-for="(item,i) of currentDataList" :key="item.name+i"
          v-model="typeObj[bindType()]" :label="item.name">
        </el-radio>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "TypeNav",
  props: {
    //类型
    ptypeDataList: {},
    //题型
    qtypeDataList: {},
    //难度
    diffDataList: {},
    //当前类型 true章节 false知识点
    currentType: {},
  },
  data() {
    return {
      ptype: "",
      qtype: "",
      diff: "",

      // 绑定数据
      typeObj: {
        ptype: "全部",
        qtype: "全部",
        diff: "全部",
      },

      // 当前激活数组
      currentDataList: [],
      // 当前激活类型
      activeType: { oldVal: "", newVal: "" },
    };
  },

  created() {
    if (this.diffDataList[0]) {
      this.diff = this.diffDataList[0].name;
    }
    if (this.ptypeDataList[0]) {
      this.ptype = this.ptypeDataList[0].name;
    }
    if (this.qtypeDataList[0]) {
      this.qtype = this.qtypeDataList[0].name;
    }
  },

  watch: {
    ptypeDataList(newVal) {
      this.ptype = newVal[0].name;
    },
    qtypeDataList(newVal) {
      this.qtype = newVal[0].name;
    },
    diffDataList(newVal) {
      this.diff = newVal[0].name;
    },

    //当切换时 改变
    currentType() {
      this.ptype = "全部";
      this.qtype = "全部";
      this.diff = "全部";

      // 绑定数据
      this.typeObj = {
        ptype: "全部",
        qtype: "全部",
        diff: "全部",
      };
    },
  },

  methods: {
    //返回绑定类型
    bindType() {
      if (this.activeType.newVal) {
        return this.activeType.newVal;
      }
    },

    //选择
    optionChange(e) {
      if (this.activeType.newVal == "ptype") {
        this.ptype = e;
      } else if (this.activeType.newVal == "qtype") {
        this.qtype = e;
      } else if (this.activeType.newVal == "diff") {
        this.diff = e;
      }
      this.$emit("typeObj", this.typeObj);
    },

    //关闭选项--------------------------------------------
    optionClick(type) {
      this.$refs.typeOption.style.height = "0";
      this.$refs.typeOption.style.minHeight = "0";
      this.$refs.typeOption.style.padding = "0";
    },

    //鼠标进入
    mouseEnter(type) {
      // 更改选项
      if (type == "ptype") {
        this.currentDataList = this.ptypeDataList;
      } else if (type == "qtype") {
        this.currentDataList = this.qtypeDataList;
      } else if (type == "diff") {
        this.currentDataList = this.diffDataList;
      }

      //给激活状态
      if (type == "typeOption") {
        this.$set(this.activeType, "newVal", this.activeType.oldVal);
        this.$refs.typeOption.style.height = "auto";
        this.$refs.typeOption.style.minHeight = "50px";
      } else {
        this.$set(this.activeType, "newVal", type);
        this.$refs.typeOption.style.height = "auto";
        this.$refs.typeOption.style.minHeight = "50px";
      }
    },

    //鼠标离开选择盒子
    mouseLeave(type) {
      this.$set(this.activeType, "oldVal", this.activeType.newVal);
      this.$set(this.activeType, "newVal", "");
      this.$refs.typeOption.style.height = "0";
      this.$refs.typeOption.style.minHeight = "0";
      this.$refs.typeOption.style.padding = "0";
    },
  },
};
</script>


<style lang="less" scoped>
.type-box {
  display: flex;
  height: 40px;
  align-items: center;

  // 类型
  .ptype {
    height: 100%;
    display: flex;
    align-items: center;
    border-radius: 3px;
    padding: 0 10px 0 19px;
    position: relative;

    .ptype-title {
      user-select: none;
      position: relative;
      span {
        margin-right: 5px;
        font-size: 14px;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
      }
    }
  }

  //题型
  .qtype {
    height: 100%;
    display: flex;
    align-items: center;
    border-radius: 3px;
    padding: 0 10px 0 19px;
    position: relative;

    .qtype-title {
      user-select: none;
      position: relative;

      span {
        margin-right: 5px;
        font-size: 14px;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
      }
    }
  }

  //难度

  .diff {
    height: 100%;
    display: flex;
    align-items: center;
    border-radius: 3px;
    padding: 0 10px 0 19px;
    position: relative;

    .diff-title {
      user-select: none;
      position: relative;

      span {
        margin-right: 5px;
        font-size: 14px;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
      }
    }
  }

  // 内容展示
  .type-option {
    width: 960px;
    height: 0;
    overflow: hidden;
    border-radius: 3px;
    position: absolute;
    top: 60px;
    left: 0px;
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
    background-color: #fff;
    display: flex;
    flex-wrap: wrap;
    z-index: 3000;

    .type-option-box {
      display: flex;
      flex-wrap: wrap;
      height: 100%;
      padding: 10px;
    }
  }

  //激活样式
  .active-option {
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);

    .type-shade {
      bottom: -9px;
      position: absolute;
      width: 100%;
      left: 0;
      height: 20px;
      background: #fff;
      z-index: 3001;
    }
  }

  .el-radio {
    margin: 10px;

    /deep/ .el-radio__input {
      display: none;
    }
    /deep/ .el-radio__label {
      padding-left: 0;

      font-size: 14px;
      font-weight: 400;

      color: rgba(51, 51, 51, 1);
      color: #333;
    }

    /deep/ .el-radio__input.is-checked + .el-radio__label {
      color: #24ba58;
    }
  }

  .el-radio:hover {
    /deep/ .el-radio__label {
      color: #24ba58;
    }
  }
}
</style>